export const COMPETITION_ID = "-Oe0VYxpfc8To1dlEm92";
